export default __webpack_public_path__ + "static/media/wreckarmor2.d5092915.png";